import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import SettingsMenu from "@/components/settings/menu";
import {Flex} from "@mantine/core";
import SettingsEmployeeTable from "@/PageComponents/Table/Component Tables/SettingsEmployeeTable";
import { createFileRoute } from '@tanstack/react-router'



const EmployeeList = (props: any) => {

  const router = useRouter()

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  return (
    <div className="settings-container">
      <Flex>
        <SettingsMenu urlPath={router.asPath} />
        <div className="settings-card">
          <SettingsEmployeeTable />
        </div>
      </Flex>
    </div>
  );
}


export default EmployeeList;

export const Route = createFileRoute('/_authenticated/settings/employee/list')({ component: EmployeeList })
